import { render } from "./InstallationMain.vue?vue&type=template&id=20953630&ts=true"
import script from "./InstallationMain.vue?vue&type=script&lang=ts"
export * from "./InstallationMain.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__